// extracted by mini-css-extract-plugin
export default {"button":"CommonBackButton_button__MZCBv","light":"CommonBackButton_light__nn5qJ"};